const technologyList = [{
    img: "/static/img/core/yuanjulihongmoshibie.png",
    imgname: "yuanjulihongmoshibie",
    reveal: "/static/img/core/yuanjulihongmoshibie_r.jpg",
    title: "远距离虹膜识别",
    desc: [
        "虹星科技致力于非受限场景下的虹膜识别技术攻关，突破传统产品识别距离近、环境要求高、用户体验差等局限，实现了1米以外运动中用户的秒级虹膜信息采集和身份识别",
        "全新的远距离虹膜识别产品支持跨区域、跨场景的信息共享和集中管控，为复杂场景下亿级规模人群的精准高效身份信息管理提供了有力保障。",
    ],
},
{
    img: "/static/img/core/hongmorenlianrongheshibie.png",
    imgname: "hongmorenlianrongheshibie",
    reveal: "/static/img/core/hongmorenlianrongheshibie_r.jpg",
    title: "虹膜人脸融合识别",
    desc: [
        "虹星科技创新应用新一代面部多模态生物特征识别技术，融合虹膜的高精度和人脸的高易用，实现双重精度保障、双重活体检测、双重防伪认证、秒级识别响应。",
        "虹膜人脸融合识别产品可结合身份证、护照、一卡通等相应证件，在进行人证对比的同时进行虹膜信息采集，",
        "进而实现基于高精度面部多模态生物特征识别的无证通行，极大解放人力，提升区域安全性。",
    ],
},
{
    img: "/static/img/core/jisuanchengxiang.png",
    imgname: "jisuanchengxiang",
    reveal: "/static/img/core/jisuanchengxiang_r.jpg",
    title: "计算成像",
    desc: [
        "虹星科技自主设计的微透镜阵列式光场相机，将成像和计算有机结合起来，克服传统光电成像瓶颈问题，显著扩展成像景深；",
        "同时捕获丰富的二维色彩和三维深度信号，实现多维光电信息的一体化采集。",
        "计算成像技术为深度估计、三维测量、特征分析提供高维度图像数据源，可广泛应用于生物特征识别、人机交互、工业视觉等领域。",
    ],
},
// {
//     img: "/static/img/core/guanjiandianjiance.png",
//     imgname: "guanjiandianjiance",
//     reveal: "/static/img/core/guanjiandianjiance_r.jpg",
//     title: "关键点检测",
//     desc: [
//         "虹星人脸关键点检测，精准定位人脸关键部位并精准跟随，明确人脸轮廓及眉、眼、鼻、嘴等各关键部位。",
//         "即使低头、侧脸等条件下也能够精准检测，为更多广泛应用提供基础。",
//     ],
// },
{
    img: "/static/img/core/huotijiance.png",
    imgname: "huotijiance",
    reveal: "/static/img/core/huotijiance_r.png",
    title: "活体检测",
    desc: [
        "提供 4 种活体检测服务，判断识别场景中的用户是否为「真人」，对照片、视频等不同类型的攻击行为进行有效的抵御，保障识别系统的安全性。",
    ],
},
{
    img: "/static/img/core/shuxingfenxi.png",
    imgname: "shuxingfenxi",
    reveal: "/static/img/core/shuxingfenxi_r.jpg",
    title: "属性分析",
    desc: [
        "虹星属性分析sdk基于轻量级深度学习模型，可以对图像或视频流进行实时分析，包括年龄，种族，性别，表情，姿态，遮挡，心率等属性。",
    ],
},
{
    img: "/static/img/core/rentizitai.png",
    imgname: "rentizitai",
    reveal: "/static/img/core/rentizitai_r.jpg",
    title: "人体姿态",
    desc: [
        "基于深度学习的人体识别方案，人体关键点技术可检测图像中的人体并返回人体矩形框位置，",
        "可精准定位包含头部、颈部、肩膀、手肘、手、臀部、膝盖、脚等14个核心关键点。支持多人检测、大动作识别等复杂场景应用。",
    ],
},
{
    img: "/static/img/core/toubuzitai.png",
    imgname: "toubuzitai",
    reveal: "/static/img/core/toubuzitai_r.jpg",
    title: "头部姿态",
    desc: [
        "虹星头部姿态估计，实时定位头部的俯仰角，滚动角和偏航角，视频帧之间连续自然，",
        "即使在大姿态的，暗光等复杂环境下也能精准检测，为其他技术研发提供了良好的技术支持",
    ],
},
{
    img: "/static/img/core/shixianzhuizong.png",
    imgname: "shixianzhuizong",
    reveal: "/static/img/core/shixianzhuizong_r.jpg",
    title: "视线追踪",
    desc: [
        "视线跟踪技术有助于确定人在数字屏幕上的注视位置，反馈眨眼频率以及瞳孔对不同刺激的反应。",
        "因此，它有助于确定一个人的视线方向，是否困倦，判断他的焦点等。",
        "该技术在智能手机、AR/VR游戏、智能汽车等领域的人机交互有着广泛的应用前景。",
        "虹星的视线跟踪技术能够准确检测人眼视线运动，操作简单自然，能够在用户无感知的条件下进行交互，操作交互速度可实时与用户观看速度进行同步。",
    ],
},
{
    img: "/static/img/core/OCR.png",
    imgname: "OCR",
    reveal: "/static/img/core/OCR_r.jpg",
    title: "OCR",
    desc: [
        "依托深度学习等人工智能技术，实现OCR字符检测和识别。",
        "可用于图片文字、证件文字、工业领域等识别，满足多种场景的OCR需求，方便用户进行文本的提取或录入。",
        "文字识别精度99.67%",
    ],
},
{
    img: "/static/img/core/ISP.png",
    imgname: "ISP",
    reveal: "/static/img/core/ISP_r.png",
    title: "ISP",
    desc: ["有机整合自动曝光、自动对焦、自动白平衡、去噪、锐化等处理模块."],
},

{
    img: "/static/img/core/PCB.png",
    imgname: "PCB",
    reveal: "/static/img/core/PCB_r.jpg",
    title: "物品外观检测",
    desc: [
        "五千万像素图像的秒级对齐方法，不仅可以适应线性位移变化，在局部区域的非线性变化时也能取得良好结果。",
    ],
},

{
    img: "/static/img/core/xingweifenxi.png",
    imgname: "xingweifenxi",
    reveal: "/static/img/core/xingweifenxi_r.jpg",
    title: "行为分析",
    desc: [
        "精确实时识别人体的头、肩、膝、踝等14个骨骼关键点；",
        "对于复杂背景，光照变化，大面积遮挡，衣着变化，夸张姿态等有极强的鲁棒性；",
        "支持不同层次的精度和速度等级，胜任从单图到视频等不同层次的检测任务。",
    ],
},

{
    img: "/static/img/core/jiancefenge.png",
    imgname: "jiancefenge",
    reveal: "/static/img/core/jiancefenge_r.png",
    title: "检测分割",
    desc: [
        "创新采用的深度学习虹膜分割算法，实现高精度的低质量虹膜图像分割，扩展了虹膜应用范围，在国际生物特征识别大会上获最佳论文奖",
    ],
},

{
    img: "/static/img/core/sanweichangjing.png",
    imgname: "sanweichangjing",
    reveal: "/static/img/core/sanweichangjing_r.png",
    title: "三维场景",
    desc: [
        "结合深度相机和RGB相机，对场景进行高精度的三维建模，理解场景中物品的空间关系，为机器人避障、人机交互、VR/AR等应用提供基础数据保障。",
    ],
},
{
    img: "/static/img/core/sanweizitaifenxi.png",
    imgname: "sanweizitaifenxi",
    // reveal: "/static/img/core/sanweizitaifenxi_r.jpg",
    title: "三维姿态分析",
    desc: [
        "综合多个2D相机的姿态估计结果，估计出人体在三维空间中的位置，实现实时的三维姿态估计，即使在多个人的场景，也可准确估计。",
    ],
},
{
    img: "/static/img/core/shipinyuyi.png",
    imgname: "shipinyuyi",
    // reveal: "/static/img/core/shipinyuyi_r.png",
    title: "视频语义",
    desc: [
        "基于单帧图像解析和时序动作分析，自动理解视频中的人、物、场景关系，提取关键信息，生成视频的文本摘要。",
    ],
},

{
    img: "/static/img/core/wenbenkexindu.png",
    imgname: "wenbenkexindu",
    // reveal: "/static/img/core/wenbenkexindu_r.png",
    title: "文本可信度",
    desc: [
        "通过词语结构特征提取可信信息的候选信息，并在候选信息的可信度计算中加入对信息源的可信度分析判断，提高信息可信度的评估准确度。",
    ],
},
{
    img: "/static/img/core/wenbenyuyi.png",
    imgname: "wenbenyuyi",
    // reveal: "/static/img/core/wenbenyuyi_r.jpg",
    title: "文本语义",
    desc: [
        "通过虹星一系列的AI算法，将文本解析为结构化的、机器可读的意图与词槽信息，便于更好的理解和满足用户需求。",
    ],
},
{
    img: "/static/img/core/draw.png",
    imgname: "draw",
    // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
    title: "用户画像",
    desc: ["采用多模态深度学习融合历史行为与个人信息，形成精准的用户画像和标签。"],
},

{
    img: "/static/img/core/check.png",
    imgname: "check",
    // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
    title: "目标检测",
    desc: [""],
},

{
    img: "/static/img/core/focus.png",
    imgname: "focus",
    // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
    title: "目标跟踪",
    desc: [""],
},
{
    img: "/static/img/core/split.png",
    imgname: "split",
    // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
    title: "目标分割",
    desc: [""],
},
{
    img: "/static/img/core/yonghuhuaxiang.png",
    imgname: "yonghuhuaxiang",
    // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
    title: "目标轨迹后处理",
    desc: [""],
},
{
    img: "/static/img/core/cloth.png",
    imgname: "cloth",
    // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
    title: "着装检测",
    desc: [""],
},
{
    img: "/static/img/core/action.png",
    imgname: "action",
    // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
    title: "行为监测",
    desc: [""],
},
{
    img: "/static/img/core/open.png",
    imgname: "open",
    // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
    title: "收集现有部分开源 语料库用于微调",
    desc: [""],
},

{
    img: "/static/img/core/rule.png",
    imgname: "rule",
    // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
    title: "双目测距",
    desc: [""],
},
{
    img: "/static/img/core/key.png",
    imgname: "key",
    // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
    title: "加密、解密",
    desc: [""],
},
{
    img: "/static/img/core/hand.png",
    imgname: "hand",
    // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
    title: "掌静脉识别",
    desc: [""],
},
{
    img: "/static/img/core/face.png",
    imgname: "face",
    // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
    title: "人脸识别",
    desc: [""],
},
{
    img: "/static/img/core/eye.png",
    imgname: "eye",
    // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
    title: "虹膜识别",
    desc: [""],
},
{
    img: "/static/img/core/dog.png",
    imgname: "dog",
    // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
    title: "狗眼识别",
    desc: [""],
},
{
    img: "/static/img/core/pigeon.png",
    imgname: "pigeon",
    // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
    title: "鸽眼识别",
    desc: [""],
},


];

export default technologyList;